export default class LeaderboardContoller {

  constructor(app) {
    this.app = app;
    this.pageId = "Leaderboard";
  }

  async show(path, model) {
    const pageId = this.pageId;
    const app = this.app;
    const userdata = app.userdata;
    const gamification = app.gamification;

    const params = path.split("/");
    let league = params[1];

    if (!league) league = userdata.rank;
    if (!league) league = "Bronze";

    //show loading
    const modelLoading = this.getModelLoading();

    app.populate(pageId, modelLoading);
    app.swapPage(pageId);

    model = await this.getModel(league);
    app.populate(pageId, model);
  }
  getModelLoading() {
    let loadingModel = {
      Name: "Loading...",
      Data: []
    }
    return loadingModel;
  }
  async getModel(league) {
    const app = this.app;
    const gamification = app.gamification;
    
    const data = await gamification.GetLeaderboard(null, league, 1000)
    let model = {
      Name: league,
      Data: data
    };
    return model;
  }

}